// extracted by mini-css-extract-plugin
export var actions = "_v7-4";
export var item = "_v7-1";
export var price = "_v7-3";
export var quantity = "_v7-2";
export var table = "_v7-0";